import { Action, Dispatch } from "redux";
import { Environments, SaveMetaData, SaveMetaDataPayload } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../ProgressSpinner/Index";
import { setNotification } from "../../../utilities/HttpRequest/Script";
import { handleException } from "../../../ErrorMessages/helper";
import { GetSelectedExtractDetail } from "../Versioning/GetVersions/helper";
import { OptOutModes, ParentOptOutModes } from "./redux/Types";
import { OptOutSlice } from "./redux/Index";

/**
 * Responsible for calling the save meta data API
 * @param saveMetaDataPayload Payload
 * @param env Environments
 * @param accessToken Authorization token
 * @param id Artefact Id
 * @param dispatch Action
 * @param translate Function to display text
 */
export const HandleSaveMetaData = async (
  saveMetaDataPayload: SaveMetaDataPayload,
  env: Environments,
  accessToken: string,
  id: string,
  dispatch: Dispatch<Action>,
  translate: Function,
  mode: OptOutModes
): Promise<any> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.SaveMetaData")));
    const response = await SaveMetaData(saveMetaDataPayload, env, accessToken, id, mode);
    if (response) {
      dispatch(OptOutSlice.actions.setOptOutList(response?.["data"]?.["metaData"]?.[0]?.["value"]));
      setNotification(dispatch, "optOut", translate("Notification.SaveOptOut"), "success");
      dispatch(OptOutSlice.actions.setOptOutMode(ParentOptOutModes.VIEW));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      await GetSelectedExtractDetail(
        dispatch,
        id,
        translate,
        accessToken
      );
    }
  } catch (ex) {
    dispatch(OptOutSlice.actions.setOptOutMode(ParentOptOutModes.VIEW));
    handleException(ex.data, dispatch, "OptOutErrMsg");
  }
};

